import { render, staticRenderFns } from "./RepairDeviceCard.vue?vue&type=template&id=b8c4720c&scoped=true&"
import script from "./RepairDeviceCard.vue?vue&type=script&lang=js&"
export * from "./RepairDeviceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c4720c",
  null
  
)

export default component.exports